
export const project_info_dic = {
    chinese_heratige_building: {
      title: "Chinese Heratige Building",
      services: [
        "Room Addition",
        "HVAC Installation - AC Unit",
        "Full Home Remodel",
        "Electrical Panel Upgrade"
        ],
      collaborators: [
        "miles_zhou",
        "henry_takahhashi",
        "fiona_youssef",
        "isaac_ramos"
        ],
      year: 2022,
      location: "Mountain View, CA",
      summary: "A warm retreat project featuring room addition, HVAC installation- AC unit and more."
    },
    eleventh_st: {
      title: "11th Street Home",
      services: 
        [
        "ADU Development",
        "GFCI Switch Replacement",
        "New Trellis and Outdoor Enhancement"],
      collaborators: [
        "jack_idris",
        "isaac_ramos",
        "oscar_kimani",
        "nina_patel"
      ],
      year: 2018,
      location: "Los Altos, CA",
      summary: "A contemporary cottage project featuring ADU development, GFCI switch replacement and more."
    },
    evergreen_village_square: {
      title: "Evergreen Village Square",

      services: [
        "Open Floor Plan Conversion",
        "Historic Window and Door Replacement",
        "Deck Construction",
        "ADU Development"
      ],
      collaborators: [
        "dana_alFarsi",
        "kevin_das",
        "lena_haddad"
      ],
      year: 2023,
      location: "Los Gatos, CA",
      summary: "A elegant hideaway project featuring ADU construction, Open floor plan conversion and more."
    },
    five_wounds_church: {
      title: "Five Wounds Church",

      services: [
        "Foundation Upgrade",
        "HVAC Installation - AC Unit",
        "Wall Upgrade",
        "Full Home Remodel",
        "Kitchen remodel"
      ],
      collaborators: [
        "george_nwosu",
        "jack_idris",
        "dana_alFarsi",
        "charlie_singh"
      ],
      year: 2016,
      location: "Santa Clara, CA",
      summary: "A rustic escape project featuring Foundation upgrade, HVAC installation- AC unit and more."
    },
    govenors_mansion: {
      title: "California Govenors Mansion",
      "services": [
        "Room Addition",
        "Full Home Remodel",
        "Plumbing Upgrade",
        
      ],
      collaborators: [
        "jack_idris",
        "fiona_youssef",
        "charlie_singh",
        "isaac_ramos"
      ],
      year: 2021,
      location: "Palo Alto, CA",
      summary: "A modern oasis project featuring Bedroom addition, Full Home Remodel and more."
    },
    san_jose_government_center: {
      title: "San Jose Government Center",

      services: [
        "Room Addition",
        "Voluntary Code Violation Correction",
        "Stair Replacement and Redesign",
        "HVAC Installation - Furnace",
        "Full Home Remodel"
      ],
      collaborators: [
        "dana_alFarsi",
        "henry_takahhashi",
        "nina_patel",
        "george_nwosu",
        "ethan_osei"
      ],
      year: 2018,
      location: "Santa Clara, CA",
      summary: "A contemporary villa project featuring Room Addition, Voluntary Code Violation Correction and more."
    },
    hayes_mansion: {
      title: "Hayes Mansion",

      services: [
        "Room Addition",
        "HVAC Installation - AC Unit",
        "Exterior Renovation"
      ],
      collaborators: [
        "lena_haddad",
        "bob_chen",
        "kevin_das",
        "miles_zhou"
      ],
      year: 2016,
      location: "Sunnyvale, CA",
      summary: "A cozy estate project featuring Room Addition, room addition and more."
    },
    hensley_residence: {
      title: "Hensley Residence",

      services: [
        "HVAC Installation - Furnace",
        "Kitchen remodel",
        "Full Home Remodel",
        "ADU Design",
        "Plumbing Upgrade"
      ],
      collaborators: [
        "george_nwosu",
        "fiona_youssef",
        "bob_chen",
        "henry_takahhashi"
      ],
      year: 2015,
      location: "Campbell, CA",
      summary: "A rustic villa project featuring HVAC installation- furnace, Kitchen remodel and more."
    },
    hotel_de_anza: {
      title: "Hotel DeAnze",

      services: [
        "Open Floor Plan Conversion",
        "Stair Replacement and Redesign",
        "Chimney Upgrade",
        "Electrical Panel Upgrade",
        "Bathroom Remodel"
      ],
      collaborators: [
        "fiona_youssef",
        "isaac_ramos",
        "ethan_osei",
        "nina_patel"
      ],
      year: 2025,
      location: "Santa Clara, CA",
      summary: "A cozy haven project featuring Open floor plan conversion, Stair replacement and redesign and more."
    },
    kelly_park_printing_office: {
      title: "Kelly Park Printing Office",

      services: [
        "Stucco and Brick Veneer Siding",
        "Historic Window and Door Replacement",
        
      ],
      collaborators: [
        "ethan_osei",
        "kevin_das",
        "jack_idris",
        "charlie_singh",
        "fiona_youssef"
      ],
      year: 2023,
      location: "San Jose, CA",
      summary: "A contemporary escape project featuring Stucco and brick veneer siding, Historic Window and Door Replacement and more."
    },
    mekong_realty: {
      title: "Mekong Realty",

      services: [
        "ADU Design",
        "Stucco and Brick Veneer Siding",
        "Interior Renovation",
        "Deck Construction"
      ],
      collaborators: [
        "lena_haddad",
        "george_nwosu"
      ],
      year: 2016,
      location: "Mountain View, CA",
      summary: "A sunny retreat project featuring ADU Design, Stucco and brick veneer siding and more."
    },
    mission_san_jose: {
      title: "Mission San Jose",
      services: [
        "Chimney Upgrade",
        "Wall Upgrade",
        "Room Addition",
        "Plumbing Upgrade",
        
      ],
      collaborators: [
        "fiona_youssef",
        "jack_idris"
      ],
      year: 2020,
      location: "Los Gatos, CA",
      summary: "A warm villa project featuring Chimney upgrade, Wall upgrade and more."
    },
    peralta_house: {
      title: "Peralta House",

      services: [
        "Patio Rebuild",
        "GFCI Switch Replacement",
        "Full Home Remodel",
        "Room Addition"
      ],
      collaborators: [
        "fiona_youssef",
        "kevin_das",
        "lena_haddad",
        "ethan_osei",
        "nina_patel"
      ],
      year: 2024,
      location: "Los Gatos, CA",
      summary: "A contemporary bungalow project featuring Patio rebuild, ADU construction and more."
    },
    portugese_historical_museum: {
      title: "Portugese Historical Museum",
      services: [
        "Bathroom Remodel",
        "Wall Upgrade",
        "Voluntary Code Violation Correction",
        "HVAC Installation - AC Unit",
        "Stair Replacement and Redesign"
      ],
      collaborators: [
        "dana_alFarsi",
        "fiona_youssef",
        "charlie_singh",
        "george_nwosu",
        "nina_patel"
      ],
      year: 2025,
      location: "San Jose, CA",
      summary: "A modern residence project featuring Bathroom remodel, Wall upgrade and more."
    },
    saint_josef_church: {
      title: "St Josef Cathedral",

      services: [
        "Open Floor Plan Conversion",
        "Electrical Panel Upgrade",
        "Re-roofing",
        "Stucco and Brick Veneer Siding"
      ],
      collaborators: [
        "bob_chen",
        "miles_zhou"
      ],
      year: 2023,
      location: "Los Altos, CA",
      summary: "A modern oasis project featuring Open floor plan conversion, Electrical panel upgrade and more."
    },
    san_jose_moa: {
      title: "San Jose MoA",

      services: [
        "Structural Upgrade",
        "Interior Renovation",
        "Room Addition",
        "Wall Upgrade"
      ],
      collaborators: [
        "miles_zhou",
        "henry_takahhashi",
        "bob_chen"
      ],
      year: 2016,
      location: "Sunnyvale, CA",
      summary: "A sleek estate project featuring Structural Upgrade, Mudroom addition and more."
    },
    santa_clara_mission: {
      title: "Mission Santa Clara",

      services: [
        "Room Addition",
        "Foundation Upgrade",
        "Structural Upgrade",
        "Exterior Renovation"
      ],
      collaborators: [
        "alice_nakamura",
        "lena_haddad",
        "ethan_osei",
        "jack_idris",
        "henry_takahhashi"
      ],
      year: 2022,
      location: "Mountain View, CA",
      summary: "A rustic estate project featuring Bedroom addition, Foundation upgrade and more."
    },
    sju_tower: {
      title: "SJU Tower",

      services: [
        "Stair Replacement and Redesign",
        "HVAC Installation - AC Unit",
        "Wall Upgrade",
        "Kitchen remodel",
        "Re-roofing",
        "Patio Rebuild"
      ],
      collaborators: [
        "george_nwosu",
        "henry_takahhashi"
      ],
      year: 2017,
      location: "Los Altos, CA",
      summary: "A sunny bungalow project featuring Stair replacement and redesign, HVAC installation- AC unit and more."
    },
    st_anthony_church: {
      title: "st Anthony Church",

      services: [
        "GFCI Switch Replacement",
        "Room Addition",
        "New Trellis and Outdoor Enhancement",
        "Full Home Remodel"
      ],
      collaborators: [
        "charlie_singh",
        "fiona_youssef",
        "nina_patel",
        "bob_chen"
      ],
      year: 2020,
      location: "San Jose, CA",
      summary: "A charming bungalow project featuring GFCI switch replacement, Room Addition and more."
    },
    third_st_home: {
      title: "3rd st Home",

      services: [
        "Voluntary Code Violation Correction",
        "Exterior Renovation",
        "Interior Renovation",
        "Room Addition"
      ],
      collaborators: [
        "miles_zhou",
        "george_nwosu",
        "isaac_ramos",
        "charlie_singh",
        "ethan_osei"
      ],
      year: 2024,
      location: "Mountain View, CA",
      summary: "A sleek estate project featuring Voluntary Code Violation Correction, Exterior renovation and more."
    },
    thomas_fallen_house: {
      title: "Thomas Fallen House",

      services: [
        "HVAC Installation - Furnace",
        "Plumbing Upgrade",
        "GFCI Switch Replacement",
        "ADU Design"
      ],
      collaborators: [
        "fiona_youssef",
        "nina_patel",
        "ethan_osei",
        "george_nwosu"
      ],
      year: 2018,
      location: "Mountain View, CA",
      summary: "A warm escape project featuring HVAC installation- furnace, Plumbing Upgrade and more."
    },
    viet_museum: {
      title: "Viet Museum",

      services: [
        "Electrical Panel Upgrade",
        "Chimney Upgrade",
        "ADU Development"
      ],
      collaborators: [
        "ethan_osei",
        "henry_takahhashi",
        "isaac_ramos",
        "dana_alFarsi",
        "george_nwosu"
      ],
      year: 2023,
      location: "Santa Clara, CA",
      summary: "A cozy villa project featuring Electrical panel upgrade, Chimney upgrade and more."
    },
    winchester: {
      title: "Winchester House",
      images: [],
      services: [
        "Exterior Renovation",
        "Plumbing Upgrade",
        "Room Addition",
        
      ],
      collaborators: [
        "lena_haddad",
        "nina_patel",
        "george_nwosu",
        "dana_alFarsi",
        "ethan_osei"
      ],
      year: 2025,
      location: "Cupertino, CA",
      summary: "A warm residence project featuring Exterior renovation, Plumbing Upgrade and more."
    }
  }

export const service_info_dic = {
bathroom_remodel: {
    service: "Bathroom Remodel",
    summary: "Upgrade your bathroom with modern fixtures, efficient layouts, and stylish finishes for improved comfort and functionality.",
    associated_people: [
        'alice_nakamura', 
        'bob_chen', 
        'dana_alFarsi', 
        'ethan_osei',  
        'isaac_ramos', 
        'jack_idris', 
        'miles_zhou', 
        'nina_patel']
},
full_home_remodel: {
    service: "Full Home Remodel",
    summary: "A complete transformation of your home’s interior and exterior, tailored to your lifestyle and design preferences.",
        associated_people: [
        'alice_nakamura', 
        'bob_chen', 
        'charlie_singh', 
        'dana_alFarsi', 
        'ethan_osei', 
        'fiona_youssef', 
        'george_nwosu', 
        'henry_takahhashi', 
        'isaac_ramos', 
        'jack_idris', 
        'kevin_das', 
        'miles_zhou', 
        'nina_patel']
},
interior_renovation: {
    service: "Interior Renovation",
    summary: "Revitalize your indoor spaces with updated layouts, fresh finishes, and enhanced functionality throughout your home.",
        associated_people: [
        'alice_nakamura', 
        'bob_chen', 
        'charlie_singh', 
        'dana_alFarsi', 
        'ethan_osei', 
        'george_nwosu', 
        'isaac_ramos', 
        'jack_idris', 
        'miles_zhou', 
        'nina_patel', ]
},
exterior_renovation: {
    service: "Exterior Renovation",
    summary: "Enhance curb appeal and protect your home with upgraded siding, finishes, and architectural details.",
        associated_people: [
        'dana_alFarsi', 
        'fiona_youssef', 
        'henry_takahhashi', 
        'jack_idris', 
        'lena_haddad',  
        'nina_patel', 
        'oscar_kimani']
},
open_floor_plan_conversion: {
    service: "Open Floor Plan Conversion",
    summary: "Remove unnecessary walls and barriers to create a spacious, flowing layout ideal for modern living.",
        associated_people: [
        'alice_nakamura', 
        'bob_chen', 
        'charlie_singh', 
        'dana_alFarsi', 
        'henry_takahhashi', 
        'isaac_ramos', 
        'jack_idris', 
        'kevin_das', 
        'miles_zhou']
},
room_additions: {
    service: "Room Addition",
    summary: "Expand your home’s footprint with seamless Room Addition designed to blend perfectly with the existing structure.",
        associated_people: [
        'alice_nakamura', 
        'bob_chen', 
        'charlie_singh', 
        'dana_alFarsi',  
        'fiona_youssef', 
        'henry_takahhashi',  
        'jack_idris', 
        'kevin_das',  
        'miles_zhou']
},
deck_construction: {
    service: "Deck Construction",
    summary: "Build a custom deck that enhances your outdoor living experience, perfect for relaxing and entertaining.",
    associated_people: [
    'alice_nakamura', 
    'bob_chen', 
    'dana_alFarsi', 
    'fiona_youssef', 
    'jack_idris', 
    'kevin_das', 
    'oscar_kimani']
},
patio_rebuild: {
    service: "Patio Rebuild",
    summary: "Restore or redesign your patio for improved aesthetics, durability, and outdoor enjoyment.",
    associated_people: [
        'alice_nakamura', 
        'bob_chen', 
        'dana_alFarsi', 
        'fiona_youssef',
        'lena_haddad', 
        'jack_idris', 
        'kevin_das', 
        'oscar_kimani']
},
adu_development: {
    service: "ADU Development",
    summary: "End-to-end ADU solutions including design, permitting, and construction to maximize your property’s potential.",
    associated_people: [
        'alice_nakamura', 
        'bob_chen', 
        'charlie_singh', 
        'dana_alFarsi', 
        'ethan_osei', 
        'fiona_youssef', 
        'george_nwosu', 
        'henry_takahhashi', 
        'isaac_ramos', 
        'jack_idris', 
        'kevin_das', 
        'miles_zhou', 
        'nina_patel', 
        'oscar_kimani']
},
re_roofing: {
    service: "Re-roofing",
    summary: "Protect your home with a durable, energy-efficient new roof using high-quality materials and expert installation.",
    associated_people: [
    'alice_nakamura', 
    'dana_alFarsi', 
    'henry_takahhashi', 
    'jack_idris']
},
stucco_and_brick_veneer_siding: {
    service: "Stucco and Brick Veneer Siding",
    summary: "Enhance your home’s appearance and durability with elegant stucco finishes and classic brick veneer detailing.",
    associated_people: [
    'alice_nakamura',
    'dana_alFarsi',
    'fiona_youssef',
    'henry_takahhashi',
    'jack_idris', 
    'oscar_kimani']
},
historic_windows_and_doors: {
    service: "Historic Window and Door Replacement",
    summary: "Preserve your home’s character while improving energy efficiency with custom replicas of historic windows and doors.",
    associated_people: [
    'alice_nakamura',
    'dana_alFarsi', 
    'fiona_youssef',
    'lena_haddad']
},
structural_upgrades: {
    service: "Structural Upgrade",
    summary: "Reinforce and improve your home’s integrity with expert upgrades to walls, foundations, and more.",
    associated_people: [
    'alice_nakamura', 
    'bob_chen', 
    'dana_alFarsi', 
    'henry_takahhashi',
    'jack_idris', 
    'kevin_das']
},
wall_upgrade: {
    service: "Wall Upgrade",
    summary: "Strengthen or modify existing walls for structural integrity or to accommodate design changes.",
    associated_people: [
        'alice_nakamura', 
        'bob_chen', 
        'dana_alFarsi', 
        'henry_takahhashi',
        'jack_idris', 
        'kevin_das']
},
foundation_upgrade: {
    service: "Foundation Upgrade",
    summary: "Ensure your home’s stability with expert foundation assessments and reinforcements or repairs.",
    associated_people: [
        'alice_nakamura', 
        'bob_chen', 
        'dana_alFarsi', 
        'henry_takahhashi',
        'jack_idris', 
        'kevin_das']
},
chimney_upgrade: {
    service: "Chimney Upgrade",
    summary: "Restore or enhance chimney structures for improved safety, function, and aesthetic appeal.",
    associated_people: [
        'alice_nakamura', 
        'bob_chen', 
        'dana_alFarsi', 
        'henry_takahhashi',
        'jack_idris', 
        'kevin_das']
},
stair_replacement_and_redesign: {
    service: "Stair Replacement and Redesign",
    summary: "Update your staircase with modern materials and layouts that improve safety and complement your home’s style.",
    associated_people: [
        'alice_nakamura', 
        'bob_chen', 
        'dana_alFarsi', 
        'henry_takahhashi',
        'jack_idris', 
        'kevin_das']
},
outdoor_enhancements: {
    service: "New Trellis and Outdoor Enhancement",
    summary: "Add charm and function to your yard with custom-built trellises, pergolas, and landscaping features.",
    associated_people: [
    'alice_nakamura',
    'dana_alFarsi', 
    'fiona_youssef',
    'jack_idris', 
    'oscar_kimani']
},
electrical_panel_upgrade: {
    service: "Electrical Panel Upgrade",
    summary: "Increase your home’s electrical capacity and safety with a modern, up-to-code panel upgrade.",
    associated_people: [
    'alice_nakamura', 
    'charlie_singh', 
    'george_nwosu']
},
gfci_switch_replacement: {
    service: "GFCI Switch Replacement",
    summary: "Improve safety with updated GFCI outlets and switches, especially in wet or high-risk areas.",
    associated_people: [
        'alice_nakamura', 
        'charlie_singh', 
        'george_nwosu']
},
furnace_installation: {
    service: "HVAC Installation - Furnace",
    summary: "Stay warm and energy-efficient with a professionally installed, modern furnace system.",
    associated_people: [ 
        'george_nwosu']
},
ac_installation: {
    service: "HVAC Installation - AC Unit",
    summary: "Cool your home efficiently with the installation of a high-performance air conditioning unit.",
    associated_people: [
    'george_nwosu']
},
plumbing_upgrades: {
    service: "Plumbing Upgrade",
    summary: "Improve water flow and efficiency with updated pipes, fixtures, and plumbing systems.",
    associated_people: [
    'alice_nakamura', 
    'dana_alFarsi', 
    'ethan_osei',
    'nina_patel']
},
violation_corrections: {
    service: "Voluntary Code Violation Correction",
    summary: "Address non-compliant features with expert corrections that meet current building codes and maintain property value.",
    associated_people: [
    'alice_nakamura', 
    'bob_chen', 
    'charlie_singh', 
    'dana_alFarsi',
    'fiona_youssef', 
    'george_nwosu', 
    'henry_takahhashi', 
    'kevin_das', 
    'lena_haddad']
}
};

export const team_info_dic = {
    alice_nakamura: {
      fullName: "Alice Nakamura",
      skills: ["Project Management", "Interior Design", "Budget Planning"],
      summary: "Alice is a skilled project manager with a keen eye for interior design and efficient budget planning.",
      links: { linkedin: "https://www.linkedin.com/in/nakavisuals/", personal: "https://ananakamura.com/" },

    },
    bob_chen: {
      fullName: "Bob Chen",
      skills: ["Framing", "Carpentry", "Structural Upgrade"],
      summary: "Bob specializes in structural work, ensuring strong frameworks and high-quality carpentry.",
      links: { linkedin: "https://www.linkedin.com/in/bchen26/", personal: "" },

    },
    charlie_singh: {
      fullName: "Charlie Singh",
      skills: ["Electrical Work", "Panel Upgrades", "GFCI Installation"],
      summary: "Charlie is an expert electrician handling panel upgrades, wiring, and safety improvements.",
      links: { linkedin: "https://www.linkedin.com/in/charles-paul-singh-7ab55b78/", personal: "" },

    },
    dana_alFarsi: {
      fullName: "Dana Al-Farsi",
      skills: ["Architectural Design", "ADU Development", "Zoning Compliance"],
      summary: "Dana brings architectural expertise, focusing on ADU development and zoning regulations.",
      links: { linkedin: "https://www.linkedin.com/in/dana-al-farsi-4195999a/", personal: "" },

    },
    ethan_osei: {
      fullName: "Ethan Osei",
      skills: ["Plumbing", "Bathroom Remodels", "Fixture Installation"],
      summary: "Ethan ensures seamless plumbing installations and specializes in high-end bathroom remodels.",
      links: { linkedin: "https://www.linkedin.com/in/benjamin-osei/", personal: "" },

    },
    fiona_youssef: {
      fullName: "Fiona Youssef",
      skills: ["Exterior Renovation", "Stucco & Brickwork", "Deck & Patio Builds"],
      summary: "Fiona transforms exteriors with quality stucco finishes, brick veneer, and outdoor living spaces.",
      links: { linkedin: "https://www.linkedin.com/in/fizhong/", personal: "" },

    },
    george_nwosu: {
      fullName: "George Nwosu",
      skills: ["HVAC Installation", "Furnace & AC Systems", "Energy Efficiency"],
      summary: "George is an HVAC expert optimizing heating and cooling systems for maximum efficiency.",
      links: { linkedin: "https://www.linkedin.com/in/george-nwosu-35871252/", personal: "" },

    },
    henry_takahhashi: {
      fullName: "Henry Takahashi",
      skills: ["Roofing", "Structural Reinforcement", "Waterproofing"],
      summary: "Henry is a roofing specialist ensuring durable, weather-resistant installations.",
      links: { linkedin: "https://www.linkedin.com/in/taitakahashi/", personal: "" },

    },
    isaac_ramos: {
      fullName: "Isaac Ramos",
      skills: ["Kitchen Remodels", "Open Floor Plan Conversion", "Custom Cabinetry"],
      summary: "Isaac is a kitchen remodel expert who excels in open layouts and custom cabinetry.",
      links: { linkedin: "https://www.linkedin.com/in/isaac-ramos-8388a779/", personal: "" },

    },
    jack_idris: {
      fullName: "Jack Idris",
      skills: ["General Contracting", "Material Sourcing", "Code Compliance"],
      summary: "Jack oversees projects from start to finish, ensuring quality materials and regulatory compliance.",
      links: { linkedin: "https://www.linkedin.com/in/mohamed-idris-23b918110/", personal: "" },

    },
    kevin_das: {
      fullName: "Kevin Das",
      skills: ["Concrete Work", "Foundation Upgrades", "Masonry"],
      summary: "Kevin specializes in foundation work, ensuring strong and stable structures.",
      links: { linkedin: "https://www.linkedin.com/in/kevin-das-8179403a/", personal: "" },

    },
    lena_haddad: {
      fullName: "Lena Haddad",
      skills: ["Historic Restoration", "Window & Door Replacement", "Detail Work"],
      summary: "Lena is passionate about restoring historic homes with precision and authenticity.",
      links: { linkedin: "https://www.linkedin.com/in/lena-haddad-9b0206277/", personal: "" },

    },
    miles_zhou: {
      fullName: "Miles Zhou",
      skills: ["Interior Renovation", "Painting & Finishes", "Flooring Installation"],
      summary: "Miles brings interior spaces to life with expert painting, flooring, and stylish finishes.",
      links: { linkedin: "https://www.linkedin.com/in/runtaozhou/", personal: "" },

    },
    nina_patel: {
      fullName: "Nina Patel",
      skills: ["Tiling", "Bathroom & Kitchen Backsplashes", "Waterproofing"],
      summary: "Nina crafts beautiful tiled surfaces, from intricate backsplashes to waterproofed bathrooms.",
      links: { linkedin: "https://www.linkedin.com/in/ninapatel01/", personal: "" },

    },
    oscar_kimani: {
      fullName: "Oscar Kimani",
      skills: ["Outdoor Enhancements", "Trellis & Pergola Construction", "Landscaping"],
      summary: "Oscar designs inviting outdoor spaces with trellises, pergolas, and expert landscaping.",
      links: { linkedin: "https://www.linkedin.com/in/oscarg21/", personal: "" },

    }
  };
